import styles from './Settings.module.css';
import { ReactComponent as Close } from '../ico/close.svg';
import { Button } from '../../UI/Button/Button';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStore';
import { useApi } from '../../../hooks/useApi';
import { Input } from '../../UI/input/input';
import { useEffect, useState } from 'react';
import { SettingModel } from '../../../models/settings';
import { TextArea } from '../../UI/TextArea/TextArea';

interface PopupProps {
  item: SettingModel | null;
  onClose: () => void;
  update: () => void;
}

const SettingPopUP: React.FC<PopupProps> = observer(
  ({ item, onClose, update }) => {
    const store = useStores();
    const api = useApi();

    const [key, setKey] = useState<string>('');
    const [value, setValue] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    const [disable, setDisable] = useState<boolean>(true);

    useEffect(() => {
      if (item) {
        setKey(item.key ?? '');
        setValue(item.value ?? '');
        setDescription(item.description ?? '');
      }
    }, [item]);

    useEffect(() => {
      if (key !== '' && value !== '') {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [key, value]);

    const handleButtonClick = async () => {
      try {
        store.notificationsStore.showPreloader();

        if (item) {
          await api.settings.update(
            {
              key,
              value,
              description,
            },
            item.id as string,
          );
        } else {
          await api.settings.create({
            key,
            value,
            description,
          });
        }

        update();
        onClose();

        store.notificationsStore.setNotifications('Успешно выполнено');
      } catch (e) {
        store.notificationsStore.setError('Ошибка при выполнении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    const deleteItem = async () => {
      try {
        store.notificationsStore.showPreloader();
        await api.settings.delete(item?.id as string);
        store.notificationsStore.setNotifications('Успешно удалено');
        update();
        onClose();
      } catch (e) {
        store.notificationsStore.setError('Ошибка при удалении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    const [showApproveDelete, setShowApproveDelete] = useState<boolean>(false);

    return (
      <>
        <div className={styles.container}>
          <div className={styles.form}>
            <Close className={styles.close} onClick={onClose} />
            <h3>{!item ? 'Добавление' : 'Изменение'} настройки</h3>
            <div className={styles.line} style={{ marginBottom: 20 }} />

            <Input
              style={{ maxWidth: '90%' }}
              value={key}
              placeholder="Ключ"
              textLabel="Ключ"
              onChange={(event) => setKey(event.target.value)}
            />

            <Input
              style={{ maxWidth: '90%' }}
              value={value}
              placeholder="Значение"
              textLabel="Значение"
              onChange={(event) => setValue(event.target.value)}
            />

            <TextArea
              maxWidth={'90%'}
              value={description}
              placeholder="Описание"
              textLabel="Описание"
              onChange={(event) => setDescription(event.target.value)}
            />

            <div className={styles.line} style={{ marginBottom: 10 }} />

            <div
              style={{ display: 'flex', width: '90%', justifyContent: 'center' }}
            >
              {!showApproveDelete && (
                <Button
                  disabled={disable}
                  onClick={handleButtonClick}
                  style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                  appearance="auth"
                >
                  {!item ? 'Создать' : 'Изменить'}
                </Button>
              )}
              {item && !showApproveDelete && (
                <Button
                  onClick={() => setShowApproveDelete(true)}
                  style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                  appearance="link"
                >
                  Удалить
                </Button>
              )}

              {showApproveDelete && (
                <div
                  style={{
                    display: 'flex',
                    width: '90%',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ marginBottom: 10 }}>Точно хотите удалить?</p>
                  <div
                    style={{
                      display: 'flex',
                      width: '90%',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      onClick={deleteItem}
                      style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                      appearance="link"
                    >
                      Удалить
                    </Button>
                    <Button
                      onClick={() => setShowApproveDelete(false)}
                      style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                      appearance="auth"
                    >
                      Отмена
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default SettingPopUP;
